<template>
	<div class="chat-history-item " :class="active ? 'active' : ''">
		<div class="message-normal">
			<div class="avatar">
				<head-image :name="showName" :size="38" :url="headImage" :id="message.sendId"></head-image>
			</div>
			<div class="content">
				<div class="top">
					<span>{{ showName }}</span>
					<span>{{ $date.toTimeText(message.sendTime) }}</span>
				</div>
				<div class="bottom">
					<div ref="chatMsgBox">
						<span class="message-text" v-if="message.type == $enums.MESSAGE_TYPE.TEXT"
							v-html="htmlText"></span>
						<div class="message-image" v-else-if="message.type == $enums.MESSAGE_TYPE.IMAGE">
							<div v-loading="sending" :element-loading-text="$t('chat.sending')"
								element-loading-background="rgba(0, 0, 0, 0.4)">
								<img class="send-image" :src="JSON.parse(message.content).thumbUrl"
									@click="showFullImageBox()" loading="lazy" />
							</div>
						</div>
						<div class="message-image" v-else-if="message.type == $enums.MESSAGE_TYPE.STICKER">
							<div v-loading="sending" :element-loading-text="$t('chat.sending')"
								element-loading-background="rgba(0, 0, 0, 0.4)">
								<img class="send-image" :src="JSON.parse(message.content).imageUrl" loading="lazy" />
							</div>
						</div>
						<div class="message-video" v-else-if="message.type == $enums.MESSAGE_TYPE.VIDEO">
							<video ref="videoPlayer" class="send-video" controls preload="none"
								:poster="JSON.parse(message.content).coverUrl"
								:src="JSON.parse(message.content).videoUrl" />
						</div>
						<div class="message-file" v-else-if="message.type == $enums.MESSAGE_TYPE.FILE">
							<div class="chat-file-box" v-loading="sending">
								<div class="chat-file-info">
									<div class="chat-file-name" @click="onPreviewFile">{{ contentData.name
									}}</div>
									<div class="chat-file-size">{{ fileSize }}</div>
								</div>
								<div class="chat-file-icon">
									<span type="primary" class="el-icon-document"></span>
								</div>
							</div>
						</div>
						<chat-user-card v-else-if="message.type == $enums.MESSAGE_TYPE.USER_CARD"
							:cardInfo="contentData"></chat-user-card>
						<chat-group-card v-else-if="message.type == $enums.MESSAGE_TYPE.GROUP_CARD"
							:cardInfo="contentData" :sendTime="message.sendTime"></chat-group-card>
						<div class="message-voice" v-else-if="message.type == $enums.MESSAGE_TYPE.AUDIO"
							@click="onPlayVoice()">
							<audio controls :src="JSON.parse(message.content).url"></audio>
						</div>
						<div class="message-media-album" v-else-if="isMediaAlbum">
							<div v-if="mediaAlbumCaption" class="album-caption">{{ mediaAlbumCaption }}</div>
							<div class="album-grid">
								<div v-for="(item, idx) in mediaAlbumItems" :key="idx" class="album-cell"
									@click.stop="onOpenAlbumItem(idx)">
									<img class="album-thumb" :src="albumThumb(item)" loading="lazy" />
									<i v-if="item.type === 'video'" class="el-icon-video-play album-video-icon"></i>
								</div>
							</div>
						</div>
						<div class="message-text" v-else-if="message.type == $enums.MESSAGE_TYPE.MERGE_FORWARD">
							{{ $t('chat.mergeForwardCount', { n: JSON.parse(message.content).messages.length }) }}
						</div>
						<div class="message-text" v-else-if="message.type == $enums.MESSAGE_TYPE.ACT_RT_VOICE">
							{{ $t('chat.voiceCallTag') }}
						</div>
						<div class="message-text" v-else-if="message.type == $enums.MESSAGE_TYPE.ACT_RT_VIDEO">
							{{ $t('chat.videoCallTag') }}
						</div>
						<div v-else class="message-text">{{ $t('chat.unsupportedType') }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import ChatUserCard from "./ChatUserCard.vue";
import ChatGroupCard from "./ChatGroupCard.vue";

export default {
	name: "chatHistoryItem",
	components: {
		HeadImage,
		ChatUserCard,
		ChatGroupCard
	},
	props: {
		active: {
			type: Boolean,
			default: false
		},
		headImage: {
			type: String,
			default: ''
		},
		showName: {
			type: String,
			required: true
		},
		quoteShowName: {
			type: String,
			default: ''
		},
		message: {
			type: Object,
			required: true
		}
	},
	data() {
		return {}
	},
	methods: {
		showFullImageBox() {
			let imageUrl = this.contentData.originUrl;
			if (imageUrl) {
				this.$eventBus.$emit("openFullImage", imageUrl);
			}
		},
		onPlayVoice() {
			if (!this.audio) {
				this.audio = new Audio();
			}
			this.audio.src = this.contentData.url;
			this.audio.play();
			this.onPlayVoice = 'RUNNING';
		},
		onPreviewFile() {
			this.$eventBus.$emit("openPreviewFile", this.contentData.url);
		},
		albumThumb(item) {
			if (!item) return '';
			if (item.type === 'video') {
				return item.coverUrl || item.thumbUrl || '';
			}
			return item.thumbUrl || item.originUrl || '';
		},
		onOpenAlbumItem(idx) {
			const item = (this.mediaAlbumItems || [])[idx];
			if (!item) return;
			if (item.type === 'video') {
				const url = item.videoUrl || item.originUrl;
				if (url) window.open(url, '_blank');
				return;
			}
			const url = item.originUrl || item.thumbUrl;
			if (url) this.$eventBus.$emit('openFullImage', url);
		}
	},
	computed: {
		sending() {
			return this.message.status == this.$enums.MESSAGE_STATUS.SENDING;
		},
		contentData() {
			return JSON.parse(this.message.content)
		},
		isMediaAlbum() {
			if (this.message.type != this.$enums.MESSAGE_TYPE.MEDIA_ALBUM) return false;
			try {
				const data = this.contentData;
				return !!(data && Array.isArray(data.items) && data.items.length);
			} catch (e) {
				return false;
			}
		},
		mediaAlbumCaption() {
			try {
				return ((this.contentData && this.contentData.caption) || '').trim();
			} catch (e) {
				return '';
			}
		},
		mediaAlbumItems() {
			try {
				return (this.contentData && Array.isArray(this.contentData.items)) ? this.contentData.items : [];
			} catch (e) {
				return [];
			}
		},
		fileSize() {
			let size = this.contentData.size;
			if (size > 1024 * 1024) {
				return Math.round(size / 1024 / 1024) + "M";
			}
			if (size > 1024) {
				return Math.round(size / 1024) + "KB";
			}
			return size + "B";
		},
		htmlText() {
			let text = this.$str.html2Escape(this.message.content)
			text = this.$url.replaceURLWithHTMLLinks(text, '')
			return this.$emo.transform(text, 'emoji-normal')
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-history-item {
	padding: 2px 8px;
	width: 620px;
	cursor: pointer;
	border-radius: 10px;
	margin-right: 20px;

	&:hover {
		background: var(--im-background-active);
	}

	&.active {
		background: var(--im-background-active-dark);
	}

	.message-normal {
		position: relative;
		font-size: 0;
		padding-left: 48px;
		min-height: 50px;
		margin: 5px 0;

		.avatar {
			position: absolute;
			width: 40px;
			height: 40px;
			top: 0;
			left: 0;
		}

		.content {
			text-align: left;

			.top {
				display: flex;
				flex-wrap: nowrap;
				color: var(--im-text-color-light);
				font-size: var(--im-font-size);
				line-height: 20px;

				span {
					margin-right: 12px;
				}
			}

			.bottom {
				padding-right: 100px;
				margin-top: 1px;

				.message-text {
					display: inline-block;
					position: relative;
					line-height: 26px;
					border-radius: 10px;
					font-size: var(--im-font-size);
					text-align: left;
					white-space: pre-wrap;
					word-break: break-word;
				}

				.message-image {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;

					.send-image {
						min-width: 100px;
						min-height: 75px;
						max-width: 200px;
						max-height: 150px;
						border-radius: 8px;
					}
				}

				.message-media-album {
					max-width: 280px;

					.album-caption {
						margin-bottom: 6px;
						font-size: var(--im-font-size);
						word-break: break-word;
						white-space: pre-wrap;
					}

					.album-grid {
						display: flex;
						flex-wrap: wrap;
						gap: 2px;
						border-radius: 6px;
						overflow: hidden;

						.album-cell {
							position: relative;
							width: calc((100% - 4px) / 3);
							aspect-ratio: 1;
							background: #f0f0f0;

							.album-thumb {
								width: 100%;
								height: 100%;
								object-fit: cover;
								display: block;
							}

							.album-video-icon {
								position: absolute;
								left: 50%;
								top: 50%;
								transform: translate(-50%, -50%);
								color: #fff;
								font-size: 20px;
								text-shadow: 0 1px 4px rgba(0, 0, 0, 0.45);
							}
						}
					}
				}

				.message-video {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;

					.send-video {
						min-width: 100px;
						min-height: 75px;
						max-width: 200px;
						max-height: 150px;
						border-radius: 8px;
						overflow: hidden;
						object-fit: contain;
					}
				}

				.message-file {
					display: flex;
					flex-wrap: nowrap;
					flex-direction: row;
					align-items: center;
					margin-bottom: 2px;

					.chat-file-box {
						display: flex;
						flex-wrap: nowrap;
						align-items: center;
						box-shadow: var(--im-box-shadow-light);
						border-radius: 4px;
						padding: 8px 15px;

						.chat-file-info {
							flex: 1;
							height: 100%;
							text-align: left;
							font-size: 14px;
							margin-right: 10px;

							.chat-file-name {
								display: inline-block;
								min-width: 160px;
								max-width: 400px;
								font-size: 14px;
								margin-bottom: 4px;
								white-space: pre-wrap;
								word-break: break-all;
								color: var(--im-color-primary);

								&:hover {
									text-decoration: underline;
								}
							}

							.chat-file-size {
								font-size: var(--im-font-size-smaller);
								color: var(--im-text-color-light);
							}
						}

						.chat-file-icon {
							font-size: 34px;
							color: #d42e07;
						}
					}
				}

				.message-voice audio {
					height: 45px;
				}
			}
		}
	}
}
</style>